import { ReactNode } from 'react';
import { AnalyticsInfo } from './AnalyticsInfo';

export type Metric = {
    label: string;
    value: ReactNode;
    detail?: ReactNode;
    explanation?: ReactNode;
};

export const MetricCards = ({ metrics }: { metrics: Metric[] }) => (
    <dl className="analytics-metrics">
        {metrics.map(metric => (
            <div key={metric.label} className="analytics-metric">
                <dt className="analytics-title-with-info">
                    {metric.label}
                    {metric.explanation && (
                        <AnalyticsInfo label={metric.label}>
                            {metric.explanation}
                        </AnalyticsInfo>
                    )}
                </dt>
                <dd className="analytics-metric-value">{metric.value}</dd>
                {metric.detail && (
                    <dd className="analytics-metric-detail">{metric.detail}</dd>
                )}
            </div>
        ))}
    </dl>
);
